import { render, staticRenderFns } from "./NewRewardPopup.vue?vue&type=template&id=82f88d38&scoped=true"
import script from "./NewRewardPopup.vue?vue&type=script&lang=js"
export * from "./NewRewardPopup.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/mkt-cms.css?vue&type=style&index=0&id=82f88d38&prod&scoped=true&lang=css&external"
import style1 from "./NewRewardPopup.vue?vue&type=style&index=1&id=82f88d38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f88d38",
  null
  
)

export default component.exports